<template>
    <div v-if="hasSeenWelcomeScreen" class="guide" :class="{'no-auth': !this.isAuthorized}">
        <div v-if="guideState !== '' && guideState !== 'countdown' && $route.name !== 'univers'" class="clickout" @click="clickout"></div>
        <CircleWrap>

            <GertCircle v-if="guide === 'gert'" @click="clickEmptyGuide" />
            <JohnCircle v-if="guide === 'john'" @click="clickEmptyGuide" />

            <!-- Gert: Facebook -->
            <div v-if="guideState === 'fb-signin' || guideState === 'fb-signout'" class="facebook-signin">
                <div class="circle-bg"></div>
                <div v-if="guide === 'gert'" class="gert-pop">
                    <div class="gert-handler">
                        <lottie :options="defaultOptions" :width="180"  :height="391" v-on:animCreated="handleAnimation($event,'gert')"/>
                    </div>
                </div>
                <div v-else-if="guide === 'john'" class="john-pop">
                    <div class="john-handler">
                        <lottie :options="defaultOptionsJohn" :width="200"  :height="391" v-on:animCreated="handleAnimation($event,'john')"/>
                    </div>
                </div>
                <Bubble angle="bottom" type="big">
                    <span v-if="!fbID">Log på med Facebook, så dine venner kan kende dig!</span>
                    <span v-else>Vil du ikke længere være tilknyttet med Facebook? Så kan du altid logge ud.</span>
                    <VFacebookLogin app-id="1384772441714572" v-model="model" @sdk-init="handleSdkInit" @login="handleLogin" @logout="handleLogout">
                        <template v-slot:login>Log ind med facebook</template>
                        <template v-slot:logout>Log ud</template>
                        <template v-slot:working>Vent venligst...</template>
                    </VFacebookLogin>
                </Bubble>
            </div>

            <!-- Gert: Need Access -->
            <div v-if="guideState === 'need-access'" class="need-access">
                <div class="circle-bg"></div>
                <div class="gert-pop">
                    <div class="gert-handler">
                        <lottie :options="defaultOptions" :width="180"  :height="391" v-on:animCreated="handleAnimation($event,'gert')"/>
                    </div>
                </div>
                <Bubble angle="right">Vil du med {{refName}}? Så skal du først lige købe entré.</Bubble>
                <div class="btns">
                    <button class="orange" @click="koebEntre">Køb entre her</button>
                    <button class="green" @click="jegHarBillet">Jeg har købt billet!</button>
                </div>
            </div>

            <!-- Gert: Welcome -->
            <div v-if="guideState === 'welcome'" class="welcome">
                <div class="circle-bg"></div>
                <div class="gert-pop">
                    <div class="gert-handler">
                        <lottie :options="defaultOptions" :width="180"  :height="391" v-on:animCreated="handleAnimation($event,'gert')"/>
                    </div>
                </div>
                <Bubble angle="right">Velkommen indenfor. Kig rundt og se dig omkring.</Bubble>
            </div>

            <!-- Gert: Info -->
            <div v-if="guideState === 'info'" class="welcome">
                <div class="circle-bg hidden"></div>
                <div class="gert-pop">
                    <div class="gert-handler">
                        <lottie :options="defaultOptions" :width="180"  :height="391" v-on:animCreated="handleAnimation($event,'gert')"/>
                    </div>
                </div>
                <Bubble angle="right">
                    <template v-if="$route.name === 'univers'">Træk rundt på universet og klik på de forskellige elementer for at navigere rundt.</template>
                    <template v-else>Er du faret vild? Du kan altid trykke tilbage på knappen oppe til venstre.</template>
                </Bubble>
            </div>

            <!-- Gert: Countdown -->
            <div v-if="guideState === 'countdown'" class="welcome countdown">
                <div class="circle-bg"></div>
                <div class="gert-pop">
                    <div class="gert-handler">
                        <lottie :options="defaultOptions" :width="180"  :height="391" v-on:animCreated="handleAnimation($event,'gert')"/>
                    </div>
                </div>
                <Bubble angle="right">Uhhh, så varer det ikke længe – vi glæder os til at holde Vorbasse Hjemmemarked sammen med dig!</Bubble>
            </div>

            <!-- Gert: Close -->
            <div v-if="guideState === 'close'" class="welcome">
                <div class="circle-bg"></div>
                <div class="gert-pop">
                    <div class="gert-handler">
                        <lottie :options="defaultOptions" :width="180"  :height="391" v-on:animCreated="handleAnimation($event,'gert')"/>
                    </div>
                </div>
            </div>

            <!-- John: Info -->
            <div v-if="guideState === 'boderne-info'" class="welcome">
                <div class="circle-bg"></div>
                <div class="john-pop">
                    <div class="john-handler">
                        <lottie :options="defaultOptionsJohn" :width="200"  :height="391" v-on:animCreated="handleAnimation($event,'john')"/>
                    </div>
                </div>
                <Bubble angle="right">Kig dig godt om i boderne, her er masser af gode tilbud.</Bubble>
            </div>

        </CircleWrap>
    </div>
</template>

<script>

	import VFacebookLogin from 'vue-facebook-login-component'

	import GertCircle from "@/assets/guide/gert-circle.svg"
	import JohnCircle from "@/assets/guide/john-circle.svg"

	import CircleWrap from "@/components/CircleWrap";
	import Bubble from "@/components/Bubble";
	import {mapState} from "vuex";
	import {setCookie, validateObjectStructure} from "@/helperFunctions";

	import Lottie from 'vue-lottie'
	import * as animationData from '@/assets/guide/animation/gert-final.json'
	import * as animationDataJohn from '@/assets/guide/animation/john-final.json'

    import gsap from 'gsap'

	export default {
		name: "Guide.vue",
		components: {
			Lottie,
			VFacebookLogin,
			Bubble,
			CircleWrap,
			GertCircle,
			JohnCircle
		},
        props: ['guide'],
        data(){
			return{
				FB: {},
				model: {},
				scope: {},
				segments: {
					gert: [
						[0,48],[24,48],[49,64] // Pop, blink, out
                    ],
                    john: [
                    	[0,20],[24,38],[48,58] // Pop, between, out
                    ]
                },
				defaultOptions: {
					animationData: animationData.default,
					autoplay: false,
					loop: false
				},
                defaultOptionsJohn: {
	                animationData: animationDataJohn.default,
	                autoplay: false,
	                loop: false
                },
				anims: {
					gert: false,
                    john: false
				},
                intervalTest: false
            }
        },
        watch: {
			guideState (to,from){
				if(to !== '' && to !== 'close'){
					let that = this
					let segment = this.segments[this.guide][0]
                    let waitForIt = setInterval(function(){
                    	if(typeof that.anims[that.guide] === 'object'){
		                    clearInterval(waitForIt)
                            gsap.to('.guide .bubble', {
                            	delay: 0.3,
                            	duration: 0.4,
                                opacity: 1,
                                y: 0,
                                x: 0,
                                ease: 'power1.easeOut'
                            })
                            if(to === 'need-access'){
	                            gsap.to('.btns button', {
		                            delay: 0.4,
		                            duration: 0.3,
		                            opacity: 1,
		                            y: 0,
		                            x: 0,
		                            ease: 'power1.easeOut',
                                    stagger: 0.1
	                            })
                            }
                            that.anims[that.guide].playSegments(segment, true)

		                    gsap.to('.circle-bg', {
			                    duration: 1,
			                    opacity: 0.2,
			                    y: 0,
			                    x: 0,
			                    scale: 1,
			                    ease: 'power1.easeOut',
		                    })

                        }
                    }, 50)
                }
				if(to === 'close'){
					this.clickout()
                }
            }
        },
		methods: {
			handleGertWinking(){
				let segment = this.segments.gert[1]
				this.anims.gert.playSegments(segment, true)
            },
			handleAnimation: function (event,type) {
				this.anims[type] = event;
			},
			clickEmptyGuide(){
				if(this.guideState === 'countdown') return
				if(this.guide === 'gert'){
					this.$store.commit('ux/setGuideState', 'info')
                }else if(this.guide === 'john'){
					this.$store.commit('ux/setGuideState', 'boderne-info')
                }
            },
			koebEntre(){
				this.$store.commit('ux/setGuideState', '')
				this.$router.push("/login/koeb-entre")
			},
			jegHarBillet(){
				this.$store.commit('ux/setGuideState', '')
				this.$router.push("/login")
			},
			handleSdkInit({ FB, scope }) {
				this.FB = FB
				this.scope = scope
			},
			clickout(){
				if(this.guideState === 'countdown') return
				let that = this
				gsap.to('.circle-bg', {
					duration: 1,
					opacity: 0,
					y: 0,
					x: 0,
                    scale: 0,
					ease: 'power1.easeOut',
				})

				if(this.guideState === 'need-access'){
					gsap.to('.btns button', {
						duration: 0.3,
						opacity: 0,
						y: 0,
						x: '-50px',
						ease: 'power1.easeOut',
					})
				}

				gsap.to('.guide .bubble', {
					duration: 0.2,
					opacity: 0,
					y: 0,
					x: '-50',
					ease: 'power1.easeOut',
                    onComplete: function(){
	                    let segment = that.segments[that.guide][2]
	                    that.anims[that.guide].playSegments(segment, true)
                    }
				})
                setTimeout(function(){
	                that.$store.commit('ux/setGuideState', '')
                }, 700)
			},
			handleLogin(response){
				if(validateObjectStructure(response, ['authResponse','status']) && response.status === 'connected' && typeof response.authResponse.userID !== 'undefined' && response.authResponse.userID !== this.fbID){
					this.FB.api('/me', {fields: 'name'}, (response) => {
						if(typeof response === 'object' && typeof response.name !== 'undefined')
						{
							this.$vorbasseSocket.emit('update-display-name',response.name);
							setCookie('whoami',response.name,24*365);
							this.$store.commit('vorbasse/setDisplayName', response.name);
						}
					});
					this.$vorbasseSocket.emit('update-fb-id',response.authResponse.userID);
					this.$store.commit('ux/setFacebookId', response.authResponse.userID);
				}
			},
			handleLogout(response){
				this.$vorbasseSocket.emit('update-fb-id','');
				this.$store.commit('ux/setFacebookId', '');
			}
		},
        computed: {
			refName(){
				switch (this.referrerName){
                    case 'tivoli':
                        return 'i tivoliet'
					case 'oelteltet':
						return 'i ølteltet'
                    case 'boderne' || 'kraemmer' :
                    	return 'i boderne'
                    case 'esport' :
                    	return 'til esport'
                    case 'partytruck' :
                    	return 'ombord på lastbilen'
                    default:
                    	return 'på Hjemmemarked'
				}
            },
			...mapState('vorbasse', {
				isAuthorized: state => state.isAuthorized
            }),
	        ...mapState('ux', {
		        fbID: state => state.fbID,
                guideState: state => state.states.guide,
		        referrerName: state => state.routeReferrerName,
		        hasSeenWelcomeScreen: state => state.hasSeenWelcomeScreen
	        }),
	        ...mapState('vorbasse', {
		        authToken: 'authToken',
	        }),
        }
	}
</script>

<style lang="scss" scoped>
    .guide{
        position: absolute;
        z-index: 10;
        .clickout{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
        &.no-auth{
            .circle{
                right: 15px;
                @media(max-width: 767px){
                    bottom: 15px;
                }
            }
        }
        .circle{
            position: fixed;
            bottom: 15px;
            right: 100px;
            background: #EEE;
            @media(max-width: 767px) and (orientation: portrait){
                bottom: 100px;
                right: 15px;
            }
            .facebook-signin, .need-access, .welcome{
                position: absolute;
                bottom: 0px;
                right: 0px;
                width: 335px;
                height: 500px;
                pointer-events: none;
                .circle-bg{
                    width: 633px;
                    height: 633px;
                    background: $black;
                    border-radius: 50%;
                    position: absolute;
                    bottom: -265px;
                    right: -200px;
                    opacity: 0;
                    transform: scale(0);
                    transform-origin: bottom right;
                    &.hidden{
                        display: none !important;
                    }
                }
                .gert-pop, .john-pop{
                    display: block;
                    width: 285px;
                    height: 397px;
                    position: absolute;
                    bottom: -55px;
                    right: -89px;
                    svg{
                        display: block;
                        position: relative;
                        top: auto;
                        left: auto;
                        transform: none;
                    }
                    .gert-handler, .john-handler{
                        position: absolute;
                        bottom: 41px;
                        right: 54px;
                    }
                    .john-handler{
                        bottom: 43px;
                        right: 71px;
                    }
                }
                .bubble{
                    pointer-events: auto;
                    opacity: 0;
                    transform: translateX(-50px);
                }
                .bubble:not(.big){
                    top: 150px;
                }
                .btns{
                    position: absolute;
                    top: 265px;
                    pointer-events: auto;
                    button{
                        max-width: 205px;
                        opacity: 0;
                        transform: translateX(-50px);
                    }
                }
                button{
                    background: #3966B8;
                    color: $white;
                    border-radius: 6px;
                    text-transform: none;
                    padding: 16px 14px;
                    margin-top: 30px;
                    border: none;
                    &.orange{
                        background: $orange;
                    }
                    &.green{
                        background: $green;
                    }
                }
            }
            .welcome{
                .bubble{
                    top: 200px !important;
                    left: -10px !important;
                    @media(max-width: 349px){
                        top: 260px !important;
                        left: 45px !important;
                        width: 180px !important;
                    }
                }
                &.countdown{
                    .bubble{
                        left: 20px !important;
                    }
                    @media(max-width: 1199px){
                        .bubble{
                            top: 320px !important;
                        }
                    }
                    @media(max-width: 767px){
                        .bubble{
                            top: 240px !important;
                        }
                    }
                }
            }
            .facebook-signin{
                @media(max-width: 850px) and (orientation: landscape){
                    .bubble.bottom.big{
                        top: 250px;
                        left: -100px;
                        max-width: 280px;
                        &:before{
                            bottom: 50px;
                            right: -31px;
                            transform: rotate(-90deg);
                        }
                        &:after{
                            bottom: 50px;
                            right: -26px;
                            transform: rotate(-90deg);
                        }
                    }
                }
                @media(max-width: 349px) and (orientation: portrait){
                    .bubble.bottom.big{
                        top: 82px;
                        left: 45px;
                    }
                }
            }
        }
    }
</style>
